<template>
	<Col class="menu-content-container width-100 height-100 overflow-y-auto py-2 px-4">
		<Col class="width-100 height-100">
			<h5 class="mb-2 bold">Publish options</h5>
		</Col>
		<PublishDropdownConfigurationItem class="mt-2" :key="option.text" v-bind="option" v-for="option in publishOptions" />
	</Col>
</template>
<script>
import { editWorkflow } from '@/store/modules/selectedWorkflow/getters';
import { updateWorkflow } from '@/store/modules/selectedWorkflow/actions';
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import PublishDropdownConfigurationItem from '@/components/Project/PublishButtonDropdown/PublishDropdownConfigurationItem.vue';
export default {
	name: 'PublishDropdownConfigurationContent',
	components: { PublishDropdownConfigurationItem },
	props: { runTestBeforePublish: { type: Boolean } },
	computed: {
		...mapGettersShorthand({ editWorkflow }),
		publishOptions() {
			return [
				// After test mechanism will be final by product, we will add this option
				// {
				// 	iconName: 'publish-perform-test',
				// 	title: 'Perform test run before publishing',
				// 	valueGetter: () => this.runTestBeforePublish,
				// 	valueSetter: (value) => this.$emit('update:runTestBeforePublish', value),
				// 	tooltipText: 'Test run will let you test your changes before publishing them to the shared users',
				// },
				{
					iconName: 'publish-async',
					title: 'Optimize performance with I-Async',
					valueGetter: () => this.editWorkflow?.async_enabled,
					valueSetter: (value) => this.updateWorkflow({ data: { async_enabled: value } }),
					tooltipText:
						'Turning this on results in faster performance by running steps in parallel (asynchronously).<br/>You can keep steps running in their place under “advanced” in step setup',
					explanationHtml: `<span>Turning this on results in faster performance by running steps in parallel (asynchronously). You can keep steps running in their place under “advanced” in step setup. <a style="color: #969596; font-weight: 300" href="https://docs.ply.io/advanced-guides/intelligent-a-sync" target="_blank">Learn more`,
				},
			];
		},
	},
	methods: {
		...mapActionsShorthand({ updateWorkflow }),
		closeMenu() {
			this.$emit('close');
		},
	},
};
</script>
<style scoped lang="scss">
.menu-content-container {
	max-height: 300px;
}
</style>
